import type { QueryKey, RefetchFn } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import type { ReturnCarrierReconciliationList } from "@msuite/utils/types";
import { returnCarrierReconciliationTableColumns } from "./table-config";

/** Props Interface */
interface ReturnCarrierReconciliationTableProps {
	reconciliation: ReturnCarrierReconciliationList | undefined;
	isLoading: boolean;
	queryKey: QueryKey | undefined;
	refetch: RefetchFn | undefined;
	persistenceKey: `${string}-table`;
}

/**
 * The carrier account of a return run's project: pallets and boxes out, back, still on site.
 *
 * Separate from the article table because the two are counted differently and settle separately —
 * a site can return every pallet while still holding material, and the Leergut round that fetches
 * empties carries no articles at all.
 */
export function ReturnCarrierReconciliationTable({
	reconciliation,
	isLoading,
	queryKey,
	refetch,
	persistenceKey,
}: ReturnCarrierReconciliationTableProps) {
	/** Render */
	return (
		<DataTable
			data={reconciliation}
			columns={returnCarrierReconciliationTableColumns}
			queryKey={queryKey}
			isLoading={isLoading}
			refetch={refetch}
			persistenceKey={persistenceKey}
			initialPinningState={{ end: ["outstandingQuantity"] }}
			menu={null}
		/>
	);
}
